'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VerticalScrollbar = function (_React$Component) {
  (0, _inherits3.default)(VerticalScrollbar, _React$Component);

  /* istanbul ignore next */
  function VerticalScrollbar() {
    (0, _classCallCheck3.default)(this, VerticalScrollbar);

    var _this = (0, _possibleConstructorReturn3.default)(this, (VerticalScrollbar.__proto__ || (0, _getPrototypeOf2.default)(VerticalScrollbar)).call(this));

    _this.state = {
      height: 0,
      dragging: false,
      start: 0
    };

    _this.jump = _this.jump.bind(_this);
    _this.startDrag = _this.startDrag.bind(_this);
    return _this;
  }

  /* istanbul ignore next */


  (0, _createClass3.default)(VerticalScrollbar, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.calculateSize(this.props);

      // Put the Listener
      document.addEventListener('mousemove', this.onDrag.bind(this));
      document.addEventListener('touchmove', this.onDrag.bind(this));
      document.addEventListener('mouseup', this.stopDrag.bind(this));
      document.addEventListener('touchend', this.stopDrag.bind(this));
    }

    /* istanbul ignore next */

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.wrapper.height !== this.props.wrapper.height || nextProps.area.height !== this.props.area.height) this.calculateSize(nextProps);
    }

    /* istanbul ignore next */

  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      // Remove the Listener
      document.removeEventListener('mousemove', this.onDrag.bind(this));
      document.removeEventListener('touchmove', this.onDrag.bind(this));
      document.removeEventListener('mouseup', this.stopDrag.bind(this));
      document.removeEventListener('touchend', this.stopDrag.bind(this));
    }

    /* istanbul ignore next */

  }, {
    key: 'onDrag',
    value: function onDrag(event) {
      var _this2 = this;

      if (this.state.dragging) {
        // Make The Parent being in the Dragging State
        this.props.onDragging();

        event.preventDefault();
        event.stopPropagation();

        var e = event.changedTouches ? event.changedTouches[0] : event;

        var yMovement = e.clientY - this.state.start;
        var yMovementPercentage = yMovement / this.props.wrapper.height * 100;

        // Update the last e.clientY
        this.setState({ start: e.clientY }, function () {
          // The next Vertical Value will be
          var next = _this2.props.scrolling + yMovementPercentage;

          // Tell the parent to change the position
          _this2.props.onChangePosition(next, 'vertical');
        });
      }
    }

    /* istanbul ignore next */

  }, {
    key: 'getSize',
    value: function getSize() {
      // The Elements
      var $scrollArea = this.container.parentElement;
      var $scrollWrapper = $scrollArea.parentElement;

      // Get new Elements Size
      var elementSize = {
        // Scroll Area Height and Width
        scrollAreaHeight: $scrollArea.children[0].clientHeight,
        scrollAreaWidth: $scrollArea.children[0].clientWidth,

        // Scroll Wrapper Height and Width
        scrollWrapperHeight: $scrollWrapper.clientHeight,
        scrollWrapperWidth: $scrollWrapper.clientWidth
      };
      return elementSize;
    }

    /* istanbul ignore next */

  }, {
    key: 'startDrag',
    value: function startDrag(event) {
      event.preventDefault();
      event.stopPropagation();

      var e = event.changedTouches ? event.changedTouches[0] : event;

      // Prepare to drag
      this.setState({
        dragging: true,
        start: e.clientY
      });
    }

    /* istanbul ignore next */

  }, {
    key: 'stopDrag',
    value: function stopDrag() {
      if (this.state.dragging) {
        // Parent Should Change the Dragging State
        this.props.onStopDrag();
        this.setState({ dragging: false });
      }
    }

    /* istanbul ignore next */

  }, {
    key: 'jump',
    value: function jump(e) {
      var _this3 = this;

      var isContainer = e.target === this.container;

      if (isContainer) {
        // Get the Element Position
        var position = this.scrollbar.getBoundingClientRect();

        // Calculate the vertical Movement
        var yMovement = e.clientY - position.top;
        var centerize = this.state.height / 2;
        var yMovementPercentage = yMovement / this.props.wrapper.height * 100 - centerize;

        // Update the last e.clientY
        this.setState({ start: e.clientY }, function () {
          // The next Vertical Value will be
          var next = _this3.props.scrolling + yMovementPercentage;

          // Tell the parent to change the position
          _this3.props.onChangePosition(next, 'vertical');
        });
      }
    }

    /* istanbul ignore next */

  }, {
    key: 'calculateSize',
    value: function calculateSize(source) {
      // Scrollbar Width
      this.setState({ height: source.wrapper.height / source.area.height * 100 });
    }

    /* istanbul ignore next */

  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var className = function className(base, name, pos, act, isAct) {
        return [base + name, base + name + pos, isAct ? base + name + act : '', isAct ? base + name + pos + act : ''].join(' ');
      };

      if (this.state.height < 100) {
        return _react2.default.createElement(
          'div',
          {
            className: className('quiver-scrollbar__scroll', '-track', ':vertical', ':dragging', this.state.dragging || this.props.draggingFromParent),
            ref: function ref(c) {
              _this4.container = c;
            },
            onClick: this.jump,
            style: { position: 'absolute' }
          },
          _react2.default.createElement('div', {
            className: className('quiver-scrollbar__scroll', '-thumb', ':vertical', ':dragging', this.state.dragging || this.props.draggingFromParent),
            ref: function ref(c) {
              _this4.scrollbar = c;
            },
            onTouchStart: this.startDrag,
            onMouseDown: this.startDrag,
            style: {
              position: 'relative',
              height: 'calc(' + this.state.height + '% - 3px)',
              top: this.props.scrolling + '%'
            }
          })
        );
      }
      return null;
    }
  }]);
  return VerticalScrollbar;
}(_react2.default.Component);

// The Props


VerticalScrollbar.propTypes = {
  draggingFromParent: _react2.default.PropTypes.bool.isRequired,
  scrolling: _react2.default.PropTypes.number.isRequired,
  wrapper: _react2.default.PropTypes.shape().isRequired,
  area: _react2.default.PropTypes.shape().isRequired,
  onChangePosition: _react2.default.PropTypes.func.isRequired,
  onDragging: _react2.default.PropTypes.func.isRequired,
  onStopDrag: _react2.default.PropTypes.func.isRequired
};

exports.default = VerticalScrollbar;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/Scrollbar/VerticalScrollbar.js
// module id = 640
// module chunks = 11